import * as SentrySvelte from "@sentry/svelte";
import type { HandleClientError } from "@sveltejs/kit";

import { dev } from "$app/environment";
import { PUBLIC_SENTRY_DSN } from "$env/static/public";

SentrySvelte.init({
  dsn: PUBLIC_SENTRY_DSN,
  environment: dev ? "development" : "production",
  //   Filter out Chrome extensions
  denyUrls: [
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Facebook flakiness
    /graph\.facebook\.com/i,
  ],
});

export const handleError: HandleClientError = ({ error, event }) => {
  const errorId = crypto.randomUUID();
  SentrySvelte.captureException(error, {
    contexts: { sveltekit: { event, errorId } },
  });

  return {
    message: "An unexpected error occurred. We're working on it!",
    errorId,
  };
};
